import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TeamList from './components/TeamList';
import TeamPlayers from './components/TeamPlayers';
import PlayerProfile from './components/PlayerProfile';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<TeamList />} />
                <Route path="/team/:teamId" element={<TeamPlayers />} />
                <Route path="/player/:playerId" element={<PlayerProfile />} />
            </Routes>
        </Router>
    );
}

export default App;
